import { useNavigate } from 'react-router';
import homeIcon from '../../static/icons/icon_home.svg';

const TopBarHomeButton = () => {
    const navigate = useNavigate();

    const viewHome = () => {
        navigate('/');
    };

    return (
        <img className="icon-button" src={homeIcon} onClick={viewHome} />
    );
};

export default TopBarHomeButton;
